module.exports = __webpack_public_path__ + "static/media/main_bg_dark.5bf640aa.png";